// extracted by mini-css-extract-plugin
export const rightBar = "blogSideBar-module--rightBar--38Qbv";
export const rightBox = "blogSideBar-module--rightBox--1Ifxp";
export const title = "blogSideBar-module--title--1aFIV";
export const card = "blogSideBar-module--card--wrlxC";
export const slider_card = "blogSideBar-module--slider_card--eU7sR";